const DEFAULT_PROMPT = (l, v)=>`Favor el valor del campo "${l}" no es válido.`;
const FORM_RULES = {
	empty: {
		check: (v)=>{
			return v && !(v === undefined || v.length==0);
		},
		prompt: (l, v)=>`Favor de ingresar el valor del campo "${l}"`,
	},
	checked: {
		check: (v)=>{
			return v && v=='on';
		},
		prompt: (l, v)=>`Favor de seleccionar el checkbox "${l}"`,
	},
	email: {
		check: (v)=>{
			return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi).test(v);
		},
		prompt: (l, v)=>`El campo "${l}" no es un correo electrónico correcto.`,
	},
    phone:{
        check: (v)=>{
            return (/^\+?\d[\d\s()-]{3,}\d/).test(v);
        },
        prompt: (l, v)=>`El campo "${l}" no es un número de teléfono correcto. Debe de ser un número telefónico.`,
    },
	range: {
		check: (v, vars)=>{
			var n = parseFloat(v);
			var min = parseFloat(vars[0]);
			var max = parseFloat(vars[1]);
			return n>=min && n<=max;
		},
		prompt: (l, v, vars)=>`El valor de campo "${l}" debe de ser entre ${vars[0]} y ${vars[1]}`,
	},
	min: {
		check: (v, vars)=>{
			var n = parseFloat(v);
			var min = parseFloat(vars[0]);
			return n>=min;
		},
		prompt: (l, v, vars)=>`El valor del campo "${l}" debe de ser mínimo ${vars[0]}`,
	},
	max: {
		check: (v, vars)=>{
			var n = parseFloat(v);
			var max = parseFloat(vars[0]);
			return n<=max;
		},
		prompt: (l, v, vars)=>`El valor del campo "${l}" debe de ser máximo ${vars[0]}`,
	},
	minLength: {
		check: (v, vars)=>{
			return v && v.length>=vars[0];
		},
		prompt: (l, v, vars)=>`El valor del campo "${l}" debe de ser de mínimo ${vars[0]} caracteres.`,
	},
	maxLength: {
		check: (v, vars)=>{
			return v && v.length<=vars[0];
		},
		prompt: (l, v, vars)=>`El valor del campo "${l}" debe de ser de máximo ${vars[0]} caracteres.`,
	},
	number: {
		check: (v)=>{
			if(typeof v==='string'){
				return (/^[0-9\.]+$/).test(v);
			}else{
				return !Number.isNaN(parseInt(v))
			}
		},
		prompt: (l, v)=>`El valor del campo "${l}" debe de ser un número.`,
	},
	float: {
		check: (v)=>{
			if(typeof v==='string'){
				return (/^([0-9]+)(\.[0-9]+)?$/).test(v);
			}else{
				return !Number.isNaN(parseFloat(v));
			}
		},
		prompt: (l, v)=>`El valor del campo "${l}" debe de ser un número decimal.`,
	},
	enum: {
		check: (v, vars)=>{
			return v && vars.indexOf(v)!=-1;
		},
		prompt: (l, v, vars)=>`El valor del campo "${l}" debe de ser de uno de los siguientes valores: ${vars.split(', ')}`
	},
	url: {
		check: (v)=>{
			return v && (/(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/i).test(v);
		},
		prompt: (l, v)=>`El valor del campo "${l}" debe de ser un URL.`
	}
}

function validateInput(name, val, rules, label, rule_prompt){
	var invalids = [], prompts = [];
	for(var r of rules){
		var raw_rule = r, is_regex = false;
		if(r instanceof RegExp){
			is_regex = true;
		}
		if(!raw_rule) continue;
		var fn;
		if(!is_regex){
			var reg = (/(?<rule>[a-z]+)(?:\[(?<values>.*)\])?/gi).exec(r)
			if(!reg || !reg.groups || !reg.groups.rule) continue;
			var rule = reg.groups.rule, v = reg.groups.values ? reg.groups.values.split(',') : [];
			fn = FORM_RULES[rule];
		}else{
			fn = { 
				check: r.test.bind(r),
				prompt: DEFAULT_PROMPT
			};
		}
		if(!fn || !fn.check) continue;
		if(!fn.check(val, v)){
			invalids.push(name);
			prompts.push(rule_prompt || fn.prompt(label || name, val, v));
			break;
		}
	}
	return { invalids, prompts };
}

function validateForm(form, rules){
	var errors = [], prompts = [];
	for(var name in form){
		var val = form[name];
		var val_rules, label, rule_prompt;
		if(Array.isArray(rules[name])){
			val_rules = [...rules[name]];
			label = null;
		}else if(rules[name]){
			val_rules = [...rules[name].rules];
			label = rules[name].label;
			rule_prompt = rules[name].prompt;
		}else continue;
		if(!val_rules || val_rules.length==0) continue;
		var pr = validateInput(name, val, val_rules, label, rule_prompt);
		errors.push(...pr.invalids);
		prompts.push(...pr.prompts);
	}
	return {
		valid: errors.length==0,
		errors,
		form,
		prompts,
	};
}

export default validateForm;
